// All needed imports
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { SelectModel } from '../../core/models/select.model';
import { BtnTooltipModel } from '../../core/models/btn.tooltip.model';
import { RadioListModel } from '../../core/models/radio-list.model';
import { RadioModel } from '../../core/models/radio.model';
import { CalendarBaseModel } from '../../core/models/calendar-base.model';
import { RadioCardListModel } from '../../../app/core/models/radio-card-list.model';
import { RadioCardModel } from '../../core/models/radio-card.model';
import { CalendarNormalModel } from '../../core/models/calendar-normal.model';
import { RadioPointModel } from '../../core/models/radio-point.model';
import { TableRow } from '../../core/models/table-row.model';
import { CheckboxModel } from '../../core/models/checkbox.model';
import { CalendarModel } from '../../core/models/calendar.model';
import { InputModel } from '../../core/models/input.model';
import { ChipsModel } from '../../core/models/chips.model';
import { Numbers } from 'src/app/utils/constants';
import {
  setRadioCardModel, setCalendarModel, setCheckboxModel,
  setRadioModel, setSelectModel, setSelectValue, setBtnTooltip, setSelectOptions,
  setInputModel, getFutureDate, setTableRowToRW, setRadioPointModel
} from 'src/app/utils/labels.utils';

// incomingStudentsTravelAsistance
const AUX_I_DATE = getFutureDate(1);

const getAdvertisingInternationalSOS = () => {
  return new RadioPointModel({
    linkFormPath: ['incomingStudentsTravelAsistance', 'termsList'],
    id: '15',
    description: 'form1.emergencyContact.sendAdvertisingInternationalSOS',
    optionOneText: 'form1.emergencyContact.yes',
    optiontwoText: 'form1.emergencyContact.no',
    checked: false
  });
};

/**
 * Export the obj to be used in the angular components app
 */
export const FORM_CONFIG = {
  // the current form step
  currentStep: new BehaviorSubject(1),
  // Increment the step
  stepIncrement() {
    this.currentStep.pipe(
      take(1)
    ).subscribe(num => {
      let numero = num;
      if (num !== Numbers.number6) {
        ++num;
        numero = num;
      }
      this.currentStep.next(numero);
    });
  },
  // Decrement the current step
  stepDecrement() {
    this.currentStep.pipe(
      take(1)
    ).subscribe(num => {
      let numero = 1;
      if (num > 1) {
        --num;
        numero = num;
      }
      this.currentStep.next(numero);
    });
  },
  // number of insured attribute
  numberOfInsured: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'numberOfInsured'],
      setSelectValue('form3.number-insured', 'form3.number-insured.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '0', id: Numbers.number0 },
      { name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 },
      { name: '3', id: Numbers.number3 }])
    )),
  // guarantee limit of medical expenses attribute
  guaranteeLimitOfMedicalExpenses: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'guaranteeLimitOfMedicalExpenses'],
      setSelectValue('form3.limit-guarantee', 'form3.limit-guarantee.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '18.000', id: Numbers.number0 },
      { name: '30.000', id: Numbers.number1 },
      { name: '120.000', id: Numbers.number2 },
      { name: '200.000', id: Numbers.number3 }]),
      setBtnTooltip('icon icon-info', 'students.guaranteeSpainOrigDes-tooltip')
    )),
  // age limit attribute
  ageLimit: ({
    tooltip: setBtnTooltip('icon icon-info', 'students.ageLimit-info')
  }),
  // insuredOlderThan60years attribute
  insuredOlderThan60years: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'insuredOlderThan60years'],
      setSelectValue('students.old-60', 'students.old-60.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: '0', id: Numbers.number0 },
      { name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 },
      { name: '3', id: Numbers.number3 }]),
      setBtnTooltip('icon icon-info', 'students.old-60-tooltip')
    )),
  insuredsPlayRiskSports: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'insuredsPlayRiskSports'],
      setSelectValue('form3.risk-play', undefined, 'label_size_7'),
      setSelectOptions('', '', [{ name: '0', id: Numbers.number0 },
      { name: '1', id: Numbers.number1 }, { name: '2', id: Numbers.number2 }]),
      setBtnTooltip('icon icon-info', 'form3.risk-play-tooltip')
    )),
  // allInsuredSameFamiliarUnit attribute
  allInsuredSameFamiliarUnit: new CheckboxModel(
    setCheckboxModel(['incomingStudentsTravelAsistance', 'allInsuredSameFamiliarUnit'],
      'form3.family-unit-label', false, undefined, new BtnTooltipModel(
        setBtnTooltip('icon icon-info', 'form3.family-unit-tooltip')))
  ),
  // insuranceTime attribute
  insuranceTime: new RadioListModel({
    linkFormPath: ['incomingStudentsTravelAsistance', 'insuranceTime'],
    radioList: [
      new RadioModel(setRadioModel('form3.duration-temporal', 'form3.duration-temporal-text', true)),
      new RadioModel(setRadioModel('form3.duration-anual', 'form3.duration-anual-text')),
      new RadioModel(setRadioModel('form3.duration-long', 'form3.duration-long-text'))
    ]
  }),
  // countryOrigin attribute
  countryOrigin: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'countryOrigin'],
      setSelectValue('form3.country-origin', 'form3.country-origin.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: 'España', id: Numbers.number0 },
      { name: 'Istanbul', id: Numbers.number1 }, { name: 'London', id: Numbers.number2 }])
    )),
  // countryDestinyI attribute
  countryDestinyI: new InputModel(
    setInputModel(['incomingStudentsTravelAsistance', 'countryDestinyI'], 'form3.country-destiny', { value: 'España', requiredText: 'form3.country-destiny.error' }, true, true)
  ),
  // countryDestiny attribute
  countryDestiny: new SelectModel(
    setSelectModel(['incomingStudentsTravelAsistance', 'countryDestiny'],
      setSelectValue('form3.country-destiny', 'form3.country-destiny.error', 'label_size_7'),
      setSelectOptions('', '', [{ name: 'España', id: Numbers.number19001 }])
    )),
  // date attribute
  date: new CalendarBaseModel({
    start: new CalendarModel(setCalendarModel(AUX_I_DATE, 'dateStart', 'form3.date-init')),
    end: new CalendarModel(setCalendarModel(new Date('1-30-2021'), 'dateEnd', 'form3.date-end'))
  }),
  // currentlyTraveling attribute
  currentlyTraveling: new CheckboxModel(setCheckboxModel(['incomingStudentsTravelAsistance',
    'currentlyTraveling'], 'form3.travel-72', false)),
  // hasCodeDerogation attribute
  hasCodeDerogation: new CheckboxModel(setCheckboxModel(['incomingStudentsTravelAsistance',
    'hasCodeDerogation'], 'form3.repeal', false)),
  // codePromotional attribute
  codePromotional: new InputModel(
    setInputModel(['incomingStudentsTravelAsistance', 'codePromotional'], 'form3.promotional',
      {})),
  // derogationCodes attribute
  derogationCodes: new ChipsModel({
    linkFormPath: ['incomingStudentsTravelAsistance', 'derogationCodes'],
    input: new InputModel(setInputModel([], 'form3.insertCodeVerification', {})),
    codes: [],
    requiredText: 'form3.insertCodeVerification.error'
  }),
  // insurance type attribute
  insuranceType: new RadioCardListModel({
    linkFormPath: ['incomingStudentsTravelAsistance', 'insuranceType'],
    radioCardList: [
      new RadioCardModel(setRadioCardModel(Numbers.number0, 'form1.coverage0',
        'students.coverage0')),
      new RadioCardModel(setRadioCardModel(Numbers.number1, 'form1.coverage1',
        'students.coverage1')),
      new RadioCardModel(setRadioCardModel(Numbers.number2, 'form1.coverage2',
        'students.coverage2'))
    ]
  }),
  // insured Data attribute
  insuredData: {
    // type owner property
    typeOwner: {
      linkFormPath: ['incomingStudentsTravelAsistance', 'insuredData', 'typeOwner'],
      value: 'Particular'
    },
    // particular property
    particular: {
      name: new InputModel(
        setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'particular', 'name'],
          'form3.particular.name', { requiredText: 'form3.particular.name.error' }, true))
    },
    // bussines property
    bussines: {
      companySector: new SelectModel(
        setSelectModel(['incomingStudentsTravelAsistance', 'insuredData', 'bussines',
          'companySector'],
          setSelectValue('form3.bussines.company-selector', 'form3.bussines.company-selector.error'),
          setSelectOptions('', '', [{ name: 'Construccion', id: Numbers.number0 },
          { name: 'Hostelería', id: Numbers.number1 }, { name: 'Turismo', id: Numbers.number2 }])
        )),
      direction: new InputModel(
        setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'bussines', 'direction'],
          'form3.bussines.direction-selector', {
          requiredText: 'form3.bussines.direction-selector.error'
        }, true))
    },
    // document type property
    documentType: new SelectModel(
      setSelectModel(['incomingStudentsTravelAsistance', 'insuredData', 'documentType'],
        setSelectValue('form3.bussines.document-selector', 'form3.bussines.document-selector.error'),
        setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
        { name: 'NIE', id: Numbers.number3 }, { name: 'Pasaporte', id: Numbers.number4 }])
      )),
    // document number property
    documentNumber: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'documentNumber'],
        'form3.doc-number', {
        maxlength: '15',
        requiredText: 'form3.default-error',
        maxlengthText: 'form3.default-maxlenght-error'
      }, true)),
    // surname 1 property
    firstSurname: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'firstSurname'],
        'form3.first-surname', { requiredText: 'form3.default-error' })),
    // surname 2 property
    secondSurname: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'secondSurname'],
        'form3.second-surname', {})),
    // email property
    email: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'email'], 'form3.email',
        { requiredText: 'form3.default-error', emailError: 'form3.default-email-error' }, true)),
    // prefix property
    prefix: new SelectModel({
      linkFormPath: ['incomingStudentsTravelAsistance', 'insuredData', 'prefix'],
      select: {
        label: 'form3.prefix',
        error: 'form3.default-error'
      },
      options: {
        default: {
          selected: 'España (+34)',
          label: 'España (+34)',
          disabled: false
        },
        list: []
      }
    }),
    // telephone property
    telephone: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'telephone'],
        'form3.telephone', {
        requiredText: 'form3.default-error',
        maxlength: '9',
        maxlengthText: 'form3.default-maxlenght-error',
        onlynumberError: 'form3.default-onlynum-error'
      }, true)),
    // direction property
    direction: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'direction'],
        'form3.direction', { requiredText: 'form3.default-error' }, true)),
    // postalCode property
    postalCode: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'postalCode'],
        'form3.postalcode', {
        requiredText: 'form3.default-error', cpError: 'form3.default-cp-error',
        maxlength: '5'
      }, true)),
    // municipality property
    municipality: new SelectModel(
      setSelectModel(['incomingStudentsTravelAsistance', 'insuredData', 'municipality'],
        setSelectValue('form3.municipality', 'form3.default-error'),
        setSelectOptions('', '', []),
        setBtnTooltip('icon icon-info', 'form1.old-70-tooltip')
      )),
    // province property
    province: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'insuredData', 'province'],
        'form3.province', { requiredText: 'form3.default-error' }, true)),
    // country property
    country: new SelectModel(
      setSelectModel(['incomingStudentsTravelAsistance', 'insuredData', 'country'],
        setSelectValue('form3.country', 'form3.default-error'),
        setSelectOptions('España', 'España', [{ name: 'España', id: Numbers.number0 },
        { name: 'Rome', id: Numbers.number1 }, { name: 'London', id: Numbers.number2 }])
      )),
    // sendAdvertisingInternationalSOS property
    sendAdvertisingInternationalSOS: getAdvertisingInternationalSOS()
  },
  // insured list data attribute
  insuredListData: {
    linkFormPath: ['incomingStudentsTravelAsistance', 'insuredListData'],
    documentType: new SelectModel(
      setSelectModel(['documentType'],
        setSelectValue('form3.listdata.document-type', 'form3.default-error'),
        setSelectOptions('', '', [{ name: 'NIF', id: Numbers.number1 },
        { name: 'NIE', id: Numbers.number3 }, { name: 'Pasaporte', id: Numbers.number4 }]),
        setBtnTooltip('icon icon-info', 'form1.old-70-tooltip')
      )),
    documentNumber: new InputModel(
      setInputModel(['documentNumber'], 'form3.listdata.document-number', {
        value: '',
        requiredText: 'form3.default-error',
        maxlengthText: 'form3.default-maxlenght-error'
      }, true)),
    name: new InputModel(
      setInputModel(['name'], 'form3.listdata.name', {
        value: '', requiredText:
          'form3.default-error'
      }, true)),
    firstSurname: new InputModel(
      setInputModel(['firstSurname'], 'form3.listdata.first-surname', {
        value: '',
        requiredText: 'form3.default-error'
      }, true)),
    secondSurname: new InputModel(
      setInputModel(['secondSurname'], 'form3.listdata.second-surname', {}, true)),
    dateBorn: new CalendarNormalModel({
      linkFormPath: ['dateBorn'],
      placeholder: 'form3.listdata.dateBorn',
      icon: 'icon-date'
    }),
    email: new InputModel(
      setInputModel(['email'], 'form3.step4.email', { emailError: 'form3.default-email-error' }))
  },
  // emergency contact attribute
  emergencyContact: {
    name: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'name'],
        'form3.emergencyContact.name', { requiredText: 'form3.default-error' })),
    firstSurname: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'firstSurname'],
        'form3.emergencyContact.first-surname', { requiredText: 'form3.default-error' })),
    secondSurname: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'secondSurname'],
        'form3.emergencyContact.second-surname', { requiredText: 'form3.default-error' })),
    prefix: new SelectModel({
      linkFormPath: ['incomingStudentsTravelAsistance', 'emergencyContact', 'prefix'],
      select: {
        label: 'form3.prefix',
        error: 'form3.default-error'
      },
      options: {
        default: {
          selected: 'España (+34)',
          label: 'España (+34)',
          disabled: false
        },
        list: []
      }
    }),
    telephone: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'telephone'],
        'form3.emergencyContact.telephone', {
        requiredText: 'form3.default-error',
        maxlength: '9',
        maxlengthText: 'form3.default-maxlenght-error',
        onlynumberError: 'form3.default-onlynum-error'
      })),
    relationWithInsured: new InputModel(
      setInputModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'relationWithInsured'], 'form3.emergencyContact.relationWithInsured', { requiredText: 'form3.default-error' })),
    acceptTerms: new CheckboxModel(setCheckboxModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'acceptTerms'], 'form3.emergencyContact.acceptTerms', false, 'form3.default-error')),
    adequacyOfProduct: new CheckboxModel(setCheckboxModel(['incomingStudentsTravelAsistance', 'emergencyContact', 'adequacyOfProduct'], 'form3.emergencyContact.adequacyOfProduct', true, 'form3.default-error')),
    treatmentOfData: new RadioPointModel({
      linkFormPath: ['incomingStudentsTravelAsistance', 'termsList'],
      id: '1',
      description: 'form3.emergencyContact.treatmentOfData',
      optionTwoSelectedSubText: 'form3.emergencyContact.treatmentOfDataConsent',
      optionOneText: 'form3.emergencyContact.yes',
      optiontwoText: 'form3.emergencyContact.no',
      checked: true
    }),
    sendAdvertisingInternationalSOS: new RadioPointModel(setRadioPointModel( ['incomingStudentsTravelAsistance', 'termsList'] , '15',
    {
      description: 'form3.emergencyContact.sendAdvertisingInternationalSOS',
      optionOneText: 'form3.emergencyContact.yes',
      optiontwoText: 'form3.emergencyContact.no'
    }, false)),
    sendAdvertisingByThirdParties: new RadioPointModel(setRadioPointModel(['incomingStudentsTravelAsistance', 'termsList'] , '9',
    {
      description: `form3.emergencyContact.sendAdvertisingByThirdParties`,
      optionOneText: 'form3.emergencyContact.yes',
      optiontwoText: 'form3.emergencyContact.no'
    }, false)),
    sendAdvertisingEventsAndNews: new RadioPointModel(setRadioPointModel(['incomingStudentsTravelAsistance', 'termsList'], '16',
    {
      description: `form3.emergencyContact.sendAdvertisingEventsAndNews`,
      optionOneText: 'form3.emergencyContact.yes',
      optiontwoText: 'form3.emergencyContact.no'
    }, false))
  },
  // guaranteeSelection attribute
  guaranteeSelection: {
    linkFormPath: ['incomingStudentsTravelAsistance', 'guaranteeSelection'],
    title: 'Seleccion de garantías',
    headerRows: {
      guarantee: 'Garantía',
      limit: 'Límite',
      extendGuarantee: 'Ampliar Límite',
      included: 'Incluido'
    },
    rows: [new TableRow(setTableRowToRW('Fallecimiento e invalidez', '10.000€', 'deathAndDisability')),
    new TableRow(setTableRowToRW('Anulación de viaje', '1.000€', 'tripCancellation')),
    new TableRow(setTableRowToRW('Perdida o robo de equipajes', '600 €', 'lostOrStolenLuggage')),
    new TableRow(setTableRowToRW('Reembolso de vacaciones', '1.000 €', 'vacationRefund'))
    ]
  }
};
